import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/lib/install";
import "@/lib/desktop";
import "@/lib/kiosk";
import { registerSW } from "@/lib/updates";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

registerSW();
